import React, { useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { hasHeroicInspiration } from '../../../shared/rules/heroicInspiration.mjs';
import { withHeroicInspiration } from '../utils/heroicInspirationService';
import apiFetch from '../../../utils/apiFetch';
import { notify } from '../../../utils/notification';

/** Heroic Inspiration on Initiative: offered once Initiative is rolled; the server rerolls the d20 until the turn changes. */
export default function HeroicInitiativePrompt({ form, characterId, campaignId, combatState, onCharacterChange, onCombatStateReconciled }) {
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);
  const participant = combatState?.participants?.find((p) => String(p.characterId) === String(characterId));
  const roll = participant?.initiativeRoll, offer = roll?.heroicInspiration;
  const show = hasHeroicInspiration(form) && offer?.status === 'pending' && offer.turnSequence === (combatState?.turnSequence || 0);
  const decide = async (decision) => {
    if (lock.current || !show) return;
    lock.current = true; setBusy(true);
    try {
      const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/initiative/heroic-inspiration`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ combatantId: String(characterId), rollId: roll.id, decision }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'Initiative could not be saved.');
      onCombatStateReconciled?.(result.combat);
      if (result.heroicInspiration) onCharacterChange?.((previous) => withHeroicInspiration(previous, result.heroicInspiration));
      const rerolled = result.combat?.participants?.find((p) => String(p.characterId) === String(characterId))?.initiativeRoll;
      if (decision === 'use' && rerolled) notify(`Heroic Inspiration: Initiative d20 rerolled (${rerolled.heroicInspiration?.die}) — Initiative ${rerolled.total}.`, 'success');
    } catch (error) { notify(error.message || 'Initiative could not be saved.', 'danger'); }
    finally { lock.current = false; setBusy(false); }
  };
  return (
    <Modal centered show={Boolean(show)} onHide={() => decide('decline')} backdrop={busy ? 'static' : true} keyboard={!busy} className="dnd-modal modern-modal" aria-label="Heroic Inspiration">
      <Modal.Header closeButton={!busy}><Modal.Title>Heroic Inspiration</Modal.Title></Modal.Header>
      <Modal.Body>You rolled {roll?.kept} on the d20 for Initiative ({roll?.total}). Expend Heroic Inspiration to reroll it? You must use the new roll.</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={busy} onClick={() => decide('decline')}>Keep the roll</Button>
        <Button disabled={busy} onClick={() => decide('use')}>{busy ? 'Rolling…' : 'Reroll the d20'}</Button>
      </Modal.Footer>
    </Modal>
  );
}
